module.exports = __webpack_public_path__ + "img/slujbele-sfintilor-de-obste-1720-pagina-de-titlu-big.a36312dd.jpg";